import projection from '../generated/pwc502f1.json';
import { AcceptanceManifest } from '../types';

export const pwc502f1AcceptanceManifest = projection as AcceptanceManifest;
